import { Component, Prop, h } from '@stencil/core';
import Icon from '../svg/caret-left.svg'
@Component({
  tag: 'cr-caret-left',
  styleUrl: '../cr-icon.css',
  shadow: true,
})
export class CrCaretLeft {
  /**
    * The size of the icon - can be 'small', 'medium' or 'large'
    */
  @Prop() size: string
  @Prop() disabled: boolean
  render() {
    return (
      <div
        part='cr-icon'
        class={`${this.size} ${this.disabled ? 'disabled' : ''}`}
        innerHTML={Icon}
      />
    );
  }

}
